import { Region } from '../models/region';
import { Injectable } from '@angular/core';
import { Store } from './store';
import { StoreHelper } from './store-helper';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from './config.service';
import { IBoundedContext } from '../../config';
import { IUserInfo } from '../models';
import 'rxjs/operator/filter';

@Injectable()
export class ManagementService {

    private _managementCtx: IBoundedContext;

    constructor(
        private _storeHelper: StoreHelper,
        private _api: ApiService,
        private _store: Store,
        private _configService: ConfigService
    ) {
        this._managementCtx = _configService.getContext('management');
    }

    /*
     * Load the regions this user has access to
     * @param userRegionIds     Logged in user instance
     */
    loadRegions(user: IUserInfo): Observable<Region[]> {
        let that = this;

        return this._api.get(this._managementCtx.url, 'regions')
            .map(regions => that._filterRegions(user, regions));
    }

    private _filterRegions(user: IUserInfo, regions: Region[]) {
        return regions.filter(region => user.regionIds.some(id => id === region.id));
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/management.service.ts